"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const ChipContext = (0, react_1.createContext)(null);
const Chip = ({ children, maxWidth, behavior, onChange, options }) => {
    const child = react_1.Children.toArray(children);
    const initialValue = Array(child?.length || 0).fill('');
    const [value, setValue] = (0, react_1.useState)(initialValue);
    return (react_1.default.createElement(ChipContext.Provider, { value: { value, setValue, behavior, initialValue, onChange } },
        react_1.default.createElement("div", { style: {
                maxWidth: `${maxWidth}px`,
                display: 'inline-flex',
                flexWrap: 'wrap',
                gap: '8px'
            } }, options?.length > 0
            ? options?.map((option, index) => (react_1.default.createElement(Button, { value: option.value, index: index, key: index }, option.children)))
            : children)));
};
const useChip = () => {
    return (0, react_1.useContext)(ChipContext);
};
const Button = ({ children, isActive, index, value }) => {
    const { value: chipValue, setValue: setChipValue, behavior, initialValue, onChange } = useChip() || {};
    const buttonCN = (0, classnames_template_literals_1.default)(`
    border
    border-solid
    rounded-[16px]
    py-[6px] px-[12px]
    hover:bg-v-100
    ${chipValue?.[index] ? 'bg-v-100' : 'bg-n-000'}
    ${chipValue?.[index] && behavior == 'single'
        ? 'border-v-600 text-v-600'
        : 'border-n-400'}
  `);
    const handleClick = () => {
        let newData = [...(chipValue || [])];
        // for behavior single, chip cannot able to unselect
        if (newData[index] && behavior == 'single')
            return;
        if (newData[index]) {
            newData[index] = '';
        }
        else {
            if (behavior == 'single')
                newData = [...(initialValue || [])];
            newData[index] = value;
        }
        setChipValue && setChipValue(newData);
        onChange && onChange(newData.filter((data) => data));
    };
    (0, react_1.useEffect)(() => {
        if (isActive) {
            const newData = [...(chipValue || [])];
            newData[index] = value;
            setChipValue && setChipValue(newData);
        }
    }, []);
    return (react_1.default.createElement("button", { className: buttonCN, style: { borderRadius: '16px' }, onClick: () => handleClick() },
        react_1.default.createElement("div", { className: "flex items-center" },
            chipValue?.[index] && behavior !== 'single' && (react_1.default.createElement(SVGIcon_1.default, { size: 16, iconName: "icon-check", fillColor: "var(--base-600)", customClass: "mr-[10px]" })),
            children)));
};
Chip.Button = Button;
exports.default = Chip;
